import { FC } from 'react';

import { UiInfoModalIcon } from 'src/components/UI/InfoModalIcon';
import { Enums } from 'src/models/enums';
import { OrganizationOldVerifyPageModelType } from 'src/models/Organization/OldVerify';
import { OrganizationOldVerifyFormValues } from 'src/pages/Organization/OldVerify/component';
import { OrganizationOldVerifyFilesPartial } from 'src/pages/Organization/OldVerify/partials/Files';
import { useNsTHelper } from 'src/utils/i18n';
import { StateFormReturnType } from 'src/utils/stateForm';
import { useStateFormValueWatch } from 'src/utils/stateForm/useFormWatch/useStateFormValueWatch';

type Props = {
  model: OrganizationOldVerifyPageModelType;
  locale: string;
  formProps: StateFormReturnType<OrganizationOldVerifyFormValues>;
  resetDirtyForm: () => void;
};

export const OrganizationOldVerifyVerificationCardPartial: FC<Props> = ({
  locale,
  model,
  formProps,
  resetDirtyForm,
}) => {
  const tHelper = useNsTHelper(locale, 'verificationCard');

  const Approved = model.StatusID === Enums.organizations.StatusCode.Approved;
  const CanDelete = !Approved;
  const CanUpload = !Approved;

  const files = useStateFormValueWatch<OrganizationOldVerifyFormValues, 'Files'>(formProps.getSubscribeProps, 'Files');

  return (
    <div className="row">
      <div className="col-xs-12">
        <div className="card hoverable text-center">
          <div className="card-content">
            <div className="row">
              <div className="col-sm12">
                <p className="text-center">
                  {tHelper('title')}
                  <UiInfoModalIcon
                    header={tHelper('hint.title')}
                    body={tHelper('hint.body')}
                    className="d-inline-flex"
                  />
                </p>

                <OrganizationOldVerifyFilesPartial
                  title={tHelper('filesTitle')}
                  files={files}
                  canDelete={CanDelete}
                  locale={locale}
                  canUpload={CanUpload}
                  fileNamePrefix={`VerifyAccount/${model.OrganizationID}/`}
                  onFileDeleted={(fileInfo) => {
                    formProps.setValue(
                      'Files',
                      files.filter(({ Uri }) => Uri !== fileInfo.Uri)
                    );

                    resetDirtyForm();
                  }}
                  onFileAdded={(data) => {
                    const files = formProps.getValue('Files');

                    files.push({
                      ID: 0, // a temporary file
                      Uri: data.fullPath,
                      Name: data.fileName,
                    });

                    formProps.setValue('Files', files);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
